const API_ADMIN = process.env.VUE_APP_API_ADMIN_LOCATION;

export default {
  fetchB2BAssessment(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}b2b-assessments`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },
  fetchB2BAssessmentPages(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}b2b-assessments/pages`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },
  fetchB2BAssessmentQuestions(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}b2b-assessments/questions`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },
  create(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}b2b-assessments`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  update(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}b2b-assessments/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}b2b-assessments/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  createPage(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}b2b-assessments/page`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  updatePage(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}b2b-assessments/page/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  deletePage(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}b2b-assessments/page/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  createQuestion(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}b2b-assessments/question`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  updateQuestion(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}b2b-assessments/question/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  deleteQuestion(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}b2b-assessments/question/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
};
